import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Logo from "../../assets/logo.png";
import "../../styles/external_receipt.css";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
function InternalReceipt() {
  const [receipt, setReceipt] = useState(null);
  const [payItems, setPayItems] = useState([]);
  const { refid } = useParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    fetch(`${Constants.apiUrl}/setup/otherpayitems/affidavit`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((data) => setPayItems(data))
      .catch(console.error);
  }, []);

  const onLoad = async () => {
    //for account registration
    try {
      console.log(`inside receipt ${refid}`);
      var mid = 0;
      if (refid.includes("JISI")) {
        var rs = refid.replace("JISI", "");
        mid = parseInt(rs);
        console.log(` the final ${refid} as ${mid}`);
      } else {
        mid = refid;
      }
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/payment/internal-receipt/${mid}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      const data = await resp.json();
      setLoading(false);

      setReceipt(data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const sealItem = payItems.find((i) => i.code === "affidavit-seal");
  const sealFee = sealItem?.fee ?? 250;

  return (
    <div>
      <div className="newreceipt">
        <div className="header">
          <img src={Logo} alt="Lagos Logo" />
          <div className="title">Lagos State Judiciary Information System</div>
          <a>Payment Receipt</a>
        </div>

        <div className="section row">
          <div className="col">
            <strong>Suit Number:</strong> {receipt?.casenumber || "N/A"}
          </div>
          <div className="col">
            <strong>Amount (₦):</strong> {receipt?.amount || "N/A"}
          </div>
          <div className="col">
            <strong>Paid On:</strong>
            {receipt?.paidon || "N/A"}{" "}
          </div>

          <div className="col">
            <strong>PayerID:</strong>
            {receipt?.payerid || "N/A"}{" "}
          </div>
          <div className="col">
            <strong>Payment By:</strong>
            {receipt?.payby || "N/A"}{" "}
          </div>
          <div className="col">
            <strong>Transaction Number:</strong>
            {receipt?.transid || "N/A"}{" "}
          </div>
          {receipt?.webguid != null && (
            <div className="col">
              <strong>Bill Reference:</strong>
              {receipt?.webguid || "N/A"}{" "}
            </div>
          )}
          <div className="col">
            <strong>Revenue Code:</strong> 51102
          </div>
          <div className="col">
            <strong>Payment Address:</strong>High Court of Lagos State
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th className="col-id">Sl.No</th>
              <th className="col-title">Description</th>
              <th className="col-id">Qty</th>
              <th>Fee</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{receipt?.lines[0]?.title || "N/A"}</td>
              <td>{1}</td>
              <td>{1500 - sealFee}</td>
              <td>{1500 - sealFee}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Exhibit(s)</td>
              <td>{receipt?.lines.length - 1 || "N/A"}</td>
              <td>250</td>
              <td>{receipt?.amount - 1500 || "N/A"}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>{sealItem?.title || "Judiciary Seal"}</td>
              <td>1</td>
              <td>{sealFee || "N/A"}</td>
              <td>{sealFee || "N/A"}</td>
            </tr>
          </tbody>
        </table>

        <div className="totals">
          Total: ₦{receipt?.amount || "N/A"}
          <br />
          Service Fee: ₦0
          <br />
          Convenience Fee: ₦0
          <br />
          <strong>Grand Total: ₦{receipt?.amount || "N/A"}</strong>
        </div>
      </div>
      <div className="no-print" style={{ textAlign: "right" }}>
        <JisButton onClick={() => window.print()}>Print</JisButton>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default InternalReceipt;
